import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const TriangleWarning = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M12 16.95a.92.92 0 0 0 .677-.274.92.92 0 0 0 .273-.676.92.92 0 0 0-.274-.677.92.92 0 0 0-.676-.273.92.92 0 0 0-.677.273.92.92 0 0 0-.273.677q0 .402.273.677a.9.9 0 0 0 .677.273m0-2.85a.92.92 0 0 0 .677-.274.92.92 0 0 0 .273-.676V10.3a.92.92 0 0 0-.274-.676A.92.92 0 0 0 12 9.35a.9.9 0 0 0-.677.274.92.92 0 0 0-.273.676v2.85q0 .404.273.677A.92.92 0 0 0 12 14.1"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.714 19.67q.214.13.475.13h17.622a.87.87 0 0 0 .475-.13.95.95 0 0 0 .332-.346q.12-.213.132-.462a.86.86 0 0 0-.132-.488L12.831 3.175a.9.9 0 0 0-.367-.356A1 1 0 0 0 12 2.7a1 1 0 0 0-.463.119.93.93 0 0 0-.368.356l-8.787 15.2a.86.86 0 0 0-.13.486q.01.249.13.463t.332.345"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(TriangleWarning) as SvgIcon;
export { ForwardRef as ReactComponent };
